import { cache } from "@/Contracts";
import { cacheConstant } from "@/Contracts/appCache";

const useDatePattern = () => {
	const userCompany = cache.get(cacheConstant.userCompany, true);
	const datePattern = userCompany?.settings?.date_pattern ?? "";
	return datePattern.replace("dd", "DD");
};

export default useDatePattern;
